export interface ConsentDefinition {
  readonly key: string;
  readonly description: string;
}

export const TEAMS_CONSENT = {
  LIST_USERS: { key: 'LIST_USERS', description: 'List Users and Groups' },
  CONFIGURE_CALL_REC_POLICIES: { key: 'CONFIGURE_CALL_REC_POLICIES', description: 'Configure Call Rec Policies' },
  RECORDER_APP_ITSELF: { key: 'RECORDER_APP_ITSELF', description: 'The Record App Itself' },
  MYBRIDGES_AUTH_APP: { key: 'MYBRIDGES_AUTH_APP', description: 'MyBridges Auth App' },
  MYBRIDGES_PRESENCE_APP_1: { key: 'MYBRIDGES_PRESENCE_APP_1', description: 'MyBridges Presence App 1' },
  MYBRIDGES_PRESENCE_APP_2: { key: 'MYBRIDGES_PRESENCE_APP_2', description: 'MyBridges Presence App 2' },
  MYBRIDGES_CDR_APP: { key: 'MYBRIDGES_CDR_APP', description: 'MyBridges CDR App' },
  MYBRIDGES_CONTACTS_APP: { key: 'MYBRIDGES_CONTACTS_APP', description: 'MyBridges Contacts App' },
  MYBRIDGES_ENTERPRISE_MANAGEMENT_APP: { key: 'MYBRIDGES_ENTERPRISE_MANAGEMENT_APP', description: 'MyBridges enterprise Management App' },
  MYBRIDGES_RBAC_APP: { key: 'MYBRIDGES_RBAC_APP', description: 'MyBridges RBAC App' },
  MYBRIDGES_USER_SYNC_APP: { key: 'MYBRIDGES_USER_SYNC_APP', description: 'MyBridges UserSync App' },
} as const;

export const ZOOM_CONSENT = {
  READ_ZOOM_MEETINGS: { key: 'READ_ZOOM_MEETINGS', description: 'Read Zoom Meetings' },
  MANAGE_ZOOM_RECORDINGS: { key: 'MANAGE_ZOOM_RECORDINGS', description: 'Manage Zoom Recordings' },
  ACCESS_USER_INFORMATION: { key: 'ACCESS_USER_INFORMATION', description: 'Access User Information' },
  MANAGE_WEBHOOKS: { key: 'MANAGE_WEBHOOKS', description: 'Manage Webhooks' },
} as const;

const ALL_CONSENT_DEFINITIONS: ConsentDefinition[] = [
  ...Object.values(TEAMS_CONSENT),
  ...Object.values(ZOOM_CONSENT),
];

export function getConsentDescription(key: string): string {
  return ALL_CONSENT_DEFINITIONS.find(c => c.key === key)?.description ?? key;
}
